// React
import { createContext } from "react"

export const PaymentCountContext = createContext<{
  data: number,
  isLoading: boolean
}>({
  data: 0,
  isLoading: false
})